import {
  Option,
  ProComboSelectMulti,
  ProComboSelectMultiWithAdd,
  ProSelect,
  ProTextField,
  ProTextFieldPrice,
  ProTextFieldWithPassword,
} from "polaris-enhance"

interface ProSchemaItemProps {
  type:
    | "ProComboSelectMultiWithAdd"
    | "ProTextField"
    | "ProSelect"
    | "ProTextFieldPrice"
    | "ProComboSelectMulti"
  value: any
  onChange: (value: any) => void
  label: string
  required?: boolean
  id?: string
  options?: Option[]
  helpText?: string
  maxLength?: number
  placeholder?: string
}
export const ProSchemaItem = (props: ProSchemaItemProps) => {
  const { type, required, ...restProps } = props

  const fnMap = {
    ProComboSelectMultiWithAdd() {
      return (
        <ProComboSelectMultiWithAdd
          {...restProps}
          onChange={(val) => {
            const trimmedVal = val.map((item) => item.trim())
            restProps.onChange(trimmedVal)
          }}
          required
        />
      )
    },
    ProSelect() {
      return <ProSelect {...restProps} options={restProps.options ?? []} />
    },
    ProTextField() {
      return (
        <ProTextField
          {...restProps}
          rules={restProps?.rules || (required ? [{ required: true }] : [])}
        />
      )
    },
    ProTextFieldPrice() {
      return (
        <ProTextFieldPrice
          {...restProps}
          rules={restProps?.rules || (required ? [{ required: true }] : [])}
        />
      )
    },
    ProComboSelectMulti() {
      return (
        <ProComboSelectMulti
          {...restProps}
          required
          // rules={restProps?.rules || (required ? [{ required: true }] : [])}
        />
      )
    },
    ProTextFieldWithPassword() {
      return <ProTextFieldWithPassword {...restProps} />
    },
  }
  return fnMap[type]?.()
}
